import { MutationTuple, OperationVariables } from '@apollo/client';
import { getApolloLink, useApolloMutation, useCookie } from '@netfront/common-library';

import { IUseKanziMutationInputVariables } from './useKanziMutation.interfaces';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useKanziMutation = <TData = any, TVariables extends OperationVariables = OperationVariables>({
  apolloLink,
  mutation,
  options,
  token,
}: IUseKanziMutationInputVariables<TData, TVariables>): MutationTuple<TData, TVariables> => {
  const { getAccessTokenCookie, getTemporaryTokenCookie } = useCookie();

  const accessToken = getAccessTokenCookie();
  const temporaryToken = getTemporaryTokenCookie();

  const authenticationLink = getApolloLink({
    apiName: 'kanzi',
    token: token ?? accessToken ?? temporaryToken,
  });

  return useApolloMutation({
    apiName: 'kanzi',
    apolloLink: apolloLink ?? authenticationLink,
    mutation,
    options,
  });
};

export { useKanziMutation };
